var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-page-skeleton',{attrs:{"show-mob-navigation":_vm.showMobNav,"expanded":_vm.isBuyerInvoicesRoute}},[_c('sidebar-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }